import type { CaseForPharmacy } from "@omony/domain";
import { LOCALE_INFO, LOCALES, type Locale } from "@omony/i18n";
import { Tile, TileGrid } from "@omony/ui";
import { useMutation } from "@tanstack/react-query";
import { Languages } from "lucide-react";
import { ErrorBanner } from "../../shared/auth/screens.js";
import { api } from "../../shared/api.js";
import { navigate } from "../../shared/hashRoute.js";
import { queryClient } from "../../shared/query.js";
import { StepFrame, useT } from "./common.js";
import { FlowStepper } from "./FlowStepper.js";
import styles from "./flow.module.css";

/** Schritt 1: Sprache der Patientin / des Patienten wählen → Vorgang anlegen */
export function NewCase() {
  const t = useT();
  const create = useMutation({
    mutationFn: (patientLanguage: Locale) =>
      api<CaseForPharmacy>("/cases", { method: "POST", body: { patientLanguage } }),
    onSuccess: (c) => {
      queryClient.setQueryData(["case", c.id], c);
      void queryClient.invalidateQueries({ queryKey: ["cases"] });
      navigate(`vorgang/${c.id}`);
    },
  });
  return (
    <div className={styles.main}>
      <FlowStepper step="sprache" />
      <StepFrame
        eyebrow={t("console.step.sprache")}
        title={t("console.language.title")}
        lead={t("console.language.lead")}
      >
        <ErrorBanner error={create.error} />
        <TileGrid label={t("console.language.title")} min={200}>
          {LOCALES.map((l) => (
            <Tile
              key={l}
              title={LOCALE_INFO[l].endonym}
              subtitle={t(`language.${l}`)}
              icon={<Languages />}
              lang={l}
              dir={LOCALE_INFO[l].dir}
              onPress={() => !create.isPending && create.mutate(l)}
            />
          ))}
        </TileGrid>
      </StepFrame>
    </div>
  );
}
